import axios from 'axios';

export default function(baseUrl = '', url, method = 'get', payload) {
  function generateRequestHeaders() {
    let headers = {
      // 'accept': 'application/json, text/javascript, */*; q=0.01',
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8', // XHR запросы с js должны иметь такой формат данных
    };
    if (!baseUrl && method !== 'get') {
      headers = {
        // Если это запрос на собственный хост, а не API, то content-type нужно оставлять по умолчанию,
        'x-csrf-token': document.getElementsByName('csrf-token')[0].content, // И добавить csrf-token токен к запросу, который находится в meta теге страницы
      };
    }
    return headers;
  }
  let serializedPayload = payload;

  if (payload) {
    // Сериализация форм даты как у jquery serialized, сервер работает корректно только со строковыми сериализированными данными
    const params = Object.entries(payload).map(([key, val]) => {
      if (Array.isArray(val) && val.length) {
        const arr = val.map((item)=>{
          return `${key}[]=${item}`;
        });
        return arr.join('&');
      }
      return `${key}=${val}`;
    }).join('&');

    serializedPayload = encodeURI(params);
  }

  return axios({
    url: `${baseUrl}${url}`,
    method,
    timeout: 30000,
    // transformRequest: [function(data) { // Из обычного обьекта сформируем FormData
    //   const fd = new FormData();
    //   _.forIn(data, (value, key) => {
    //     fd.append(key, value);
    //   });
    //   return fd;
    // }],
    headers: generateRequestHeaders(),
    data: serializedPayload,
  })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
}
